import React from 'react';
import './LegalPage.css';
import TextType from './TextType';


const TermsOfService = () => {
  return (
    
    <div className="legal-page">
      <h1>Terms of Service Agreement</h1>
      <p className="last-updated">Effective Date: August 2025</p>
      
      <section className="intro">
        <p>Welcome to Charlotte Student Hub ("Service"). These Terms of Service ("Terms") govern your access to and use of our platform.</p>
      </section>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing or using the Service, you agree to be bound by these Terms and our Privacy Policy. If you disagree with any part, you may not access the Service.</p>
      </section>

      <section>
        <h2>2. User Accounts</h2>
        <p>When creating an account, you must provide accurate information. You are responsible for maintaining the confidentiality of your account credentials.</p>
        <ul className="legal-list">
          <li>You must be at least 13 years old to use this Service</li>
          <li>Accounts are non-transferable</li>
          <li>We reserve the right to suspend or terminate accounts</li>
        </ul>
      </section>

      <section>
        <h2>3. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul className="legal-list">
          <li>Violate any laws or third-party rights</li>
          <li>Post harmful, abusive, or illegal content</li>
          <li>Use the Service for commercial purposes without authorization</li>
          <li>Attempt to gain unauthorized access to our systems</li>
        </ul>
      </section>

      <section>
        <h2>4. Intellectual Property</h2>
        <p>All content, features, and functionality on Charlotte Student Hub are owned by us or our licensors and are protected by copyright and other intellectual property laws.</p>
        <p>You may not reproduce, distribute, modify, or create derivative works without our express permission.</p>
      </section>

      <section>
        <h2>5. User Content</h2>
        <p>By posting content, you grant us a non-exclusive, worldwide license to use, display, and distribute your content in connection with the Service.</p>
        <p>You represent that you own or have the necessary rights to any content you post.</p>
      </section>

      <section>
        <h2>6. Termination</h2>
        <p>We may terminate or suspend your account immediately, without prior notice, for any violation of these Terms.</p>
      </section>

      <section>
        <h2>7. Disclaimers</h2>
        <p>The Service is provided "as-is" without warranties of any kind. We do not guarantee that:</p>
        <ul className="legal-list">
          <li>The Service will be uninterrupted or error-free</li>
          <li>Results from using the Service will be accurate or reliable</li>
        </ul>
      </section>

      <section>
        <h2>8. Limitation of Liability</h2>
        <p>Charlotte Student Hub shall not be liable for any indirect, incidental, or consequential damages arising from:</p>
        <ul className="legal-list">
          <li>Use or inability to use the Service</li>
          <li>Unauthorized access to your transmissions</li>
          <li>Any conduct of third parties on the Service</li>
        </ul>
      </section>

      <section>
        <h2>9. Governing Law</h2>
        <p>These Terms shall be governed by the laws of North Carolina without regard to its conflict of law provisions.</p>
      </section>

      <section>
        <h2>10. Changes to Terms</h2>
        <p>We reserve the right to modify these Terms at any time. Continued use after changes constitutes acceptance.</p>
      </section>

     <TextType 
  text={["Text typing effect", "for your websites", "Happy coding!"]}
  typingSpeed={75}
  pauseDuration={1500}
  showCursor={true}
  cursorCharacter="|"
/>
    </div>
  );
};

export default TermsOfService;